/**
 * Learn more about theme events at
 * https://help.switchthemes.co/shapes/developer/theme-events/overview.html
 */

window.theme = window.theme || {};

window.theme.events = {
  version: '1.0',
};

document.addEventListener('theme:update:cart', async () => {
  document.dispatchEvent(new CustomEvent('shapes:cart:lock'));

  try {
    const response = await fetch(
      `${window.location.pathname}?sections=cart-items,cart-footer,cart-item-count,cart-live-region`
    );
    const data = await response.json();

    if (!data.status) {
      document.dispatchEvent(
        new CustomEvent('shapes:cart:update', {
          bubbles: true,
          detail: {
            response: {
              sections: {
                ...data,
              },
            },
          },
        })
      );
    }
  } catch (e) {
    console.error(e);
    document.getElementById('cart-errors').textContent =
      theme.strings.cartError;
    document.dispatchEvent(
      new CustomEvent('theme:cart:error:other', {
        detail: {
          message: theme.strings.cartError,
          error: e,
        },
      })
    );
  } finally {
    document.dispatchEvent(new CustomEvent('shapes:cart:unlock'));
  }
});

const getCartDrawerEl = () => {
  return document.querySelector('[data-cart-drawer]');
};

document.addEventListener('cart-will-open', async () => {
  const cartDrawerEl = getCartDrawerEl();

  const detail = {
    cartDrawerEl,
  };

  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:opening', {
      detail,
    })
  );
});

document.addEventListener('cart-is-open', async () => {
  const cartDrawerEl = getCartDrawerEl();

  const detail = {
    cartDrawerEl,
  };

  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:open', {
      detail,
    })
  );
});

document.addEventListener('cart-will-close', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closing', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.addEventListener('cart-is-closed', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closed', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.addEventListener('theme:open:cart-drawer', () => {
  if (
    window.theme.settings.cartType === 'modal' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').closeAll();

    Alpine.store('modals').open('cart');
  }
});

document.addEventListener('theme:close:cart-drawer', () => {
  if (
    window.theme.settings.cartType === 'modal' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').close('cart');
  }
});

const cartChangeEventHandler = (e) => {
  const { cartItemCount, itemsRootEl, lineItemEl, variantId, key } = e.detail;

  document.dispatchEvent(
    new CustomEvent('theme:cart:change', {
      detail: {
        type: e.type,
        cartItemCount,
        itemsRootEl,
        lineItemEl,
        variantId,
        key,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener('theme:product:add', cartChangeEventHandler);
document.addEventListener('theme:line-item:change', cartChangeEventHandler);

const cartErrorEventHandler = (e) => {
  document.dispatchEvent(
    new CustomEvent('theme:cart:error', {
      detail: {
        type: e.type,
        message: e.detail.message,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener(
  'theme:product:error:add-to-cart',
  cartErrorEventHandler
);

document.addEventListener('theme:line-item:error', cartErrorEventHandler);
document.addEventListener('theme:cart:error:other', cartErrorEventHandler);

/**
 * Set `window.themeEventsDebugMode` to `true` to log events
 * outside the theme editor
 */

if (Shopify.designMode || window.themeEventsDebugMode) {
  const themeEvents = [
    'theme:variant:change',
    'theme:product:add',
    'theme:line-item:change',
    'theme:cart:change',
    'theme:cart:update',
    'theme:cart-drawer:opening',
    'theme:cart-drawer:open',
    'theme:cart-drawer:closing',
    'theme:cart-drawer:closed',
    'theme:product:error:add-to-cart',
    'theme:line-item:error',
    'theme:cart:error:other',
    'theme:cart:error',
  ];

  const aggregateEvents = ['theme:cart:change', 'theme:cart:error'];

  for (const eventName of themeEvents) {
    let color;

    if (eventName.includes('error')) {
      color = '#ef4444';
    } else {
      color = '#22c55e';
    }

    const message = [
      `%c\u25CF %c${eventName}`,
      `color: ${color};`,
      'font-weight: bold;',
    ];

    if (aggregateEvents.includes(eventName)) {
      document.addEventListener(eventName, (e) => {
        console.groupCollapsed(...message);
        console.log(
          `Underlying event: %c${e.detail.type}`,
          'font-weight: bold;'
        );
        console.log('Event detail:', e.detail);
        console.groupEnd();
      });
    } else {
      document.addEventListener(eventName, (e) => {
        console.log(...message, e.detail);
      });
    }
  }
}

/* Peprly custom cart bar, keep drawer progress in sync with cart changes. */
(() => {
  if (window.__peprlyCustomCartBarReady) return;
  window.__peprlyCustomCartBarReady = true;

  const routeRoot = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  let timer = null;
  let lastCart = null;

  const clampPercent = (value) => Math.max(0, Math.min(100, value));

  const formatMoney = (cents, bar) => {
    const amount = Number(cents || 0);
    const moneyFormat = bar && bar.dataset ? bar.dataset.moneyFormat : '';
    const currency = bar && bar.dataset ? bar.dataset.currency : window.theme && window.theme.moneyCurrency;

    if (window.Shopify && typeof Shopify.formatMoney === 'function' && moneyFormat) {
      return Shopify.formatMoney(amount, moneyFormat);
    }

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: amount % 100 === 0 ? 0 : 2,
      }).format(amount / 100);
    } catch (error) {
      return '$' + (amount / 100).toFixed(amount % 100 === 0 ? 0 : 2);
    }
  };

  const labelWithAmount = (template, amount) => String(template || '').replace('[amount]', amount);

  const updateBarsFromCart = (cart) => {
    if (!cart) return;
    lastCart = cart;

    document.querySelectorAll('[data-peprly-custom-cart-bar]').forEach((bar) => {
      const subtotal = Number(cart.total_price || 0);
      const shippingThreshold = Number(bar.dataset.shippingThreshold || 0);
      const giftThreshold = Number(bar.dataset.giftThreshold || 0);
      const giftProgress = giftThreshold > 0 ? clampPercent((subtotal / giftThreshold) * 100) : 0;
      const remainingShipping = Math.max(shippingThreshold - subtotal, 0);
      const remainingGift = Math.max(giftThreshold - subtotal, 0);
      const message = bar.querySelector('[data-sccb-message]');
      const fill = bar.querySelector('[data-sccb-fill]');
      const shippingLabel = bar.querySelector('[data-sccb-shipping-label]');
      const giftLabel = bar.querySelector('[data-sccb-gift-label]');

      if (fill) fill.style.setProperty('--sccb-progress', `${giftProgress}%`);

      if (message) {
        if (giftThreshold > 0 && subtotal >= giftThreshold) {
          message.textContent = bar.dataset.giftUnlockedText || 'You unlocked your free gift.';
        } else if (shippingThreshold > 0 && subtotal < shippingThreshold) {
          message.textContent = labelWithAmount(bar.dataset.shippingText || 'Spend [amount] more for free shipping.', formatMoney(remainingShipping, bar));
        } else {
          message.textContent = labelWithAmount(bar.dataset.giftText || 'Spend [amount] more to unlock a free gift.', formatMoney(remainingGift, bar));
        }
      }

      if (shippingLabel) {
        shippingLabel.textContent = shippingThreshold > 0 && subtotal >= shippingThreshold
          ? (bar.dataset.shippingUnlockedLabel || 'Free shipping unlocked')
          : `${bar.dataset.shippingLabel || 'Free shipping at'} ${formatMoney(shippingThreshold, bar)}`;
      }

      if (giftLabel) {
        giftLabel.textContent = giftThreshold > 0 && subtotal >= giftThreshold
          ? (bar.dataset.giftUnlockedLabel || 'Free gift unlocked')
          : `${bar.dataset.giftLabel || 'Free gift at'} ${formatMoney(giftThreshold, bar)}`;
      }
    });
  };

  const fetchCartAndUpdateBars = async () => {
    try {
      const response = await fetch(`${routeRoot}cart.js`, {
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      });
      if (!response.ok) return;
      updateBarsFromCart(await response.json());
    } catch (error) {
      console.error('Peprly custom cart bar update failed', error);
    }
  };

  const scheduleBarUpdate = () => {
    clearTimeout(timer);
    timer = setTimeout(fetchCartAndUpdateBars, 80);
  };

  const maybeUseEventCart = (event) => {
    const response = event && event.detail && event.detail.response;
    if (response && typeof response.total_price !== 'undefined') {
      updateBarsFromCart(response);
    }
    scheduleBarUpdate();
  };

  [
    'shapes:cart:afteradditem',
    'shapes:cart:cartqtychange',
    'shapes:cart:update',
    'theme:cart:update',
    'theme:line-item:change',
    'theme:product:add',
    'cart:updated',
    'cart:update',
    'cart:change',
  ].forEach((eventName) => {
    window.addEventListener(eventName, maybeUseEventCart);
    document.addEventListener(eventName, maybeUseEventCart);
    document.body && document.body.addEventListener(eventName, maybeUseEventCart);
  });

  document.addEventListener('cart-is-open', () => {
    if (lastCart) updateBarsFromCart(lastCart);
    scheduleBarUpdate();
  });

  document.addEventListener('theme:cart-drawer:open', () => {
    if (lastCart) updateBarsFromCart(lastCart);
    scheduleBarUpdate();
  });

  document.addEventListener('DOMContentLoaded', scheduleBarUpdate);

  // Shapes drawer replaces cart DOM after quantity/remove actions. Watch for the custom bar being re-rendered and immediately sync it.
  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    mutations.forEach((mutation) => {
      mutation.addedNodes && mutation.addedNodes.forEach((node) => {
        if (!node || node.nodeType !== 1) return;
        if ((node.matches && node.matches('[data-peprly-custom-cart-bar]')) || (node.querySelector && node.querySelector('[data-peprly-custom-cart-bar]'))) {
          shouldUpdate = true;
        }
      });
    });
    if (shouldUpdate) {
      if (lastCart) updateBarsFromCart(lastCart);
      scheduleBarUpdate();
    }
  });

  if (document.body) observer.observe(document.body, { childList: true, subtree: true });

  // Catch cart AJAX calls even when the theme does not emit a public event after remove/update.
  if (!window.__peprlyCustomCartFetchPatched && window.fetch) {
    window.__peprlyCustomCartFetchPatched = true;
    const nativeFetch = window.fetch.bind(window);
    window.fetch = async (...args) => {
      const response = await nativeFetch(...args);
      try {
        const target = String(args[0] && args[0].url ? args[0].url : args[0] || '');
        if (/\/cart(\/change|\/update|\/add)?\.js|\/cart\?/i.test(target) || target.includes('/cart/change') || target.includes('/cart/update') || target.includes('/cart/add')) {
          setTimeout(scheduleBarUpdate, 40);
          setTimeout(scheduleBarUpdate, 220);

          // Keep custom and native product forms synchronized with the Shapes cart drawer.
          if (target.includes('/cart/add') && response && response.ok) {
            setTimeout(() => {
              document.dispatchEvent(new CustomEvent('theme:update:cart', { bubbles: true }));
            }, 0);
            setTimeout(() => {
              document.dispatchEvent(new CustomEvent('theme:update:cart', { bubbles: true }));
            }, 180);
          }
        }
      } catch (error) {}
      return response;
    };
  }

  scheduleBarUpdate();
})();
